import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

const BASE_CLASS = 'stripe-element';

const classes = {
  base: BASE_CLASS,
  complete: `${BASE_CLASS}--complete`,
  empty: `${BASE_CLASS}--empty`,
  focus: `${BASE_CLASS}--focus`,
  invalid: `${BASE_CLASS}--invalid`,
  webkitAutofill: `${BASE_CLASS}--webkit-autofill`,
};

const style = {
  base: {
    color: '#202020',
    fontFamily: '"Inter", sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    '::placeholder': {
      color: '#646464',
    },
  },
  invalid: {
    color: '#BF133E',
  },
};

const cleanup = (instance) => {
  instance.stripeElement.destroy();
};

class StripeElementModifier extends Modifier {
  stripeElement = null;
  onchange = null;

  constructor() {
    super(...arguments);
    registerDestructor(this, cleanup);
  }

  modify(element, [stripeElements], { onchange, placeholder, type }) {
    this.onchange = onchange;

    if (!this.stripeElement) {
      this.stripeElement = stripeElements.create(type, {
        classes,
        style,
        placeholder,
      });

      this.stripeElement.on('change', (event) => {
        this.onchange(event);
      });

      this.stripeElement.mount(element);
    }
  }
}

export default StripeElementModifier;
